import * as Types from '../../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type EditChargesEeCodeMutationVariables = Types.Exact<{
  input: Types.EditProjectChargesEeCodeCommand;
}>;


export type EditChargesEeCodeMutation = { __typename?: 'MutationModel', projectCharges: { __typename?: 'ProjectChargesMutationModel', editEeCode: { __typename?: 'ValidationResponse', errors: Array<{ __typename?: 'ValidationError', argumentName?: string | null, message: string }> } } };


export const EditChargesEeCodeDocument = gql`
    mutation EditChargesEeCode($input: EditProjectChargesEeCodeCommand!) {
  projectCharges {
    editEeCode(input: $input) {
      errors {
        argumentName
        message
      }
    }
  }
}
    `;
export type EditChargesEeCodeMutationFn = Apollo.MutationFunction<EditChargesEeCodeMutation, EditChargesEeCodeMutationVariables>;

/**
 * __useEditChargesEeCodeMutation__
 *
 * To run a mutation, you first call `useEditChargesEeCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditChargesEeCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editChargesEeCodeMutation, { data, loading, error }] = useEditChargesEeCodeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditChargesEeCodeMutation(baseOptions?: Apollo.MutationHookOptions<EditChargesEeCodeMutation, EditChargesEeCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditChargesEeCodeMutation, EditChargesEeCodeMutationVariables>(EditChargesEeCodeDocument, options);
      }
export type EditChargesEeCodeMutationHookResult = ReturnType<typeof useEditChargesEeCodeMutation>;
export type EditChargesEeCodeMutationResult = Apollo.MutationResult<EditChargesEeCodeMutation>;
export type EditChargesEeCodeMutationOptions = Apollo.BaseMutationOptions<EditChargesEeCodeMutation, EditChargesEeCodeMutationVariables>;